const initialState = {
    matchingRuleNamesForSelectionBox: [],
    mappingMatchings: [],
    ruleData: [],
    allRulesDetails: [],
    predictedRule: [],
    extractedData: [],
};

export default initialState;
